import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../../data/images';
import { cultureSteps } from '../../data/navigation';
import { Reveal } from '../ui/Reveal';
export function CultureStory() {
  return <section className="bg-surface" data-id="element-60" data-mp="1bgp4fya4silv">
      <div className="mx-auto grid max-w-7xl items-center gap-12 px-5 py-20 lg:grid-cols-2 lg:gap-20 lg:px-8 lg:py-28" data-id="element-61" data-mp="1bfns7qhdpq2k">
        <img src={images.craft} alt="Handen kraken arganpitten met een steen, zoals in de vrouwencoöperaties in de Souss-vallei" className="aspect-[4/3] w-full object-cover" data-id="element-62" data-mp="11ju9tqgzb2cv" />
        <div data-id="element-63" data-mp="sjflei8px755">
          <Reveal data-id="element-64" data-mp="sjxs68t0b3rb">
            <h2 className="font-display text-4xl uppercase leading-[0.98] tracking-display text-ink sm:text-5xl" data-id="element-65" data-mp="skgxmq1gzzog">
              Van de arganboom <em className="italic text-pink" data-id="element-66" data-mp="xjtve5tvqr5t">naar jouw huid</em>
            </h2>
            <p className="mt-5 max-w-lg text-lg font-light leading-relaxed text-muted" data-id="element-67" data-mp="2mxp1163ihjlp">
              Amira groeide op tussen de heuvels van de Anti-Atlas, waar verzorging bestond uit henna, arganolie en gedroogde planten.
              Die eenvoud brengen we naar jou.
            </p>
          </Reveal>
          <ol className="mt-10 border-t border-line" data-id="element-68" data-mp="1awf2szlk4zkt">
            {cultureSteps.map((s, i) => <li key={s.title} className="grid grid-cols-[2.5rem_1fr] gap-4 border-b border-line py-5" data-id="element-69" data-mp="1os0lkp176n4s" data-mpi={i}>
                <span className="font-display text-2xl text-pink" data-id="element-70" data-mp="1jt5tsxl95o8j">{i + 1}</span>
                <div data-id="element-71" data-mp="w1imdz3lh5wn">
                  <h3 className="font-semibold text-ink" data-id="element-72" data-mp="w321vnhffcxd">{s.title}</h3>
                  <p className="mt-1 text-[15px] font-light leading-relaxed text-muted" data-id="element-73" data-mp="s185vsi6ex3j">{s.text}</p>
                </div>
              </li>)}
          </ol>
          <Link to="/over-amira" className="mt-8 inline-flex h-12 items-center border border-ink px-7 text-xs font-semibold uppercase tracking-[0.14em] text-ink transition-colors duration-150 hover:bg-ink hover:text-white" data-id="element-74" data-mp="11027jxad6dny">
            Lees ons verhaal
          </Link>
        </div>
      </div>
    </section>;
}